import React, {useState, useEffect } from 'react';
import { Modal, Input, Button , notification} from 'antd';
import { regenerateAiQuestion } from '../../services/ide-apis';
import AiGeneratingModal from '../labAssignments/aiGenerating-modal'; 


const { TextArea } = Input;

const AiRegenerateConfirmModal = ({ open, onCancel ,questionData, handleAiQuestionData}) => {
    const [instructions, setInstructions] = useState('');
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (open && questionData) {
          setInstructions('');
        }
      }, [open, questionData]);

    const fnGenerateAiQuesion = async (instructions = '') => {
        try {
            const reqObj = {
                aiProjectType: questionData?.aiProjectType || '',
                grade: questionData?.grade || '',
                topic: questionData?.topic || '',
                question: questionData?.question || '',
                questionTitle: questionData?.questionTitle || '',
            };
    
            // Add instructions if user typed any
            if (instructions && instructions.trim() !== '') {
            reqObj.additionalInstructions = instructions;
            }
            setIsLoading(true);
            const response = await regenerateAiQuestion(reqObj);
            setIsLoading(false)
            if (response?.data?.statusCode === 200) {
                notification.success({
                  message: 'AI Question Generated',
                  description: 'New AI question generated successfully!',
                });
                if (response.data.response.example) {
                    response.data.response.question = response.data.response.question +  "<br>" + response.data.response.example;
                }
                const questionObj = { questionTitle: response.data.response.questionTitle, question: response.data.response.question}
                handleAiQuestionData(questionObj);
                onCancel();
            } else {
                setIsLoading(false)
                notification.error({
                message: 'Failed to Generate',
                description: response?.data?.message || 'Unexpected error occurred.',
                });
            }

        } catch (error) {
            notification.error({
                message: 'Error',
                description: error.message,
            });
            onCancel();
        }
    };

    const handleAdd = () => {
        if (!instructions.trim()) {
            notification.error({
                message: 'Error',
                description: 'Please enter some additional instructions before clicking Add.',
            });
            return;
            }
            fnGenerateAiQuesion(instructions);
    };

    const handleSkip = () => {
        fnGenerateAiQuesion('');
    };



  return (
    <>
    <Modal
      title="Confirm Action"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
    >
      <p className="poppins-regular">Do you want to give additional instructions to AI?</p>

      <label className="poppins-medium" style={{ marginBottom: 8, display: 'block' }}>
        Additional Instructions ( Optional )
      </label>
      <TextArea
        rows={4}
        placeholder="Type additional instructions here..."
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
        <Button onClick={handleSkip}   style={{ borderColor: '#E75C4A', color: '#E75C4A' }}>
          Skip
        </Button>
        <Button type="primary" onClick={handleAdd}   style={{ background: '#E75C4A', border: 'none' }}>
          Add
        </Button>
      </div>
    </Modal>
    <AiGeneratingModal open={isLoading} />
    </>
  );
};

export default AiRegenerateConfirmModal;
